module.exports = __webpack_public_path__ + "static/media/diamond.a073e4e5.svg";